import React from 'react';
import Dropzone from 'react-dropzone'; // Used for uploading image into react
import { v4 as randomString } from 'uuid'; // used to create random string for S3 url
import axios from 'axios';

// Upload design button...

export default function UploadFile(props) {

  const { setFile } = props; // setFile gets passed down from parent component to set the file

  // On drop takes the file uploaded through react-dropzone formats the file and link to be ready for AWS upload
  async function onDrop(files) {
    let changeFile = files[0]
    const replaceName = `${changeFile.name.replace(/\s/g, '-')}`;
    const fileName = `${randomString()}-${replaceName}`;
    const fileType = changeFile.type;
    // console.log(fileName)
    generateAWSLink({ fileName, fileType, file: files[0] });
  };

  // This function takes the fileName, FileType, and file from onDrop, and will send that info to the back end to create our URL to upload the image to. 
  function generateAWSLink(obj) {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_amazon_policy', file_name: obj.fileName, content_type: obj.fileType }).then(res => {
      const signedRequest = res.data.signedurl
      // console.log(res.data)
      const { file } = obj
      // console.log(obj.fileType)
      setFile(() => {
        return 'https://s3.amazonaws.com/ion-proposalist/' + obj.fileName
      })
      const header = {
        headers: {
          'Content-Type': obj.fileType
        }
      };
      putInAWS({ signedRequest, header, file}, obj.fileName);
    }).catch(err => console.log('error at generateLink', err));
  };

  // This function will upload the image to amazon using the url given to use in generateAWSLink, with the file and header
  function putInAWS(obj, fName) {
    const { header, signedRequest, file } = obj;
    // console.log(obj)
    axios.put(signedRequest, file, header).then(() => {
      // console.log('https://s3.amazonaws.com/ion-proposalist/' + fName)
    }).catch(err => console.log('error at addToAws', err))
  };

  return (
    <Dropzone onDropAccepted={onDrop} multiple={false}>
      {/* DROPZONE ALLOWS US TO DROP A FILE INTO REACT, ondrop accepted will call the onDrop function */}
      {
        ({ getRootProps, getInputProps }) => (
          <section className="aws-drop-zone">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <button className="btn btn-outline-info ms-2 float-end" style={{ width: "200px" }}>Upload Design</button>
            </div>
          </section>
        )
      }
    </Dropzone>
  )
}